import { Caption } from '@liveauctioneers/hammer-ui-core/text';

import type { SimilarItemAlert } from '@/redux/modules/similarItemAlerts/similarItemAlerts.types';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { MySimilarItemAlertRow } from './MySimilarItemAlertRow';
import { MySimilarItemAlertsTableRow } from './MySimilarItemAlertsTableRow';

type Props = {
    alerts: SimilarItemAlert[];
};

export const MySimilarItemAlertsTable = ({ alerts }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <>
            <MySimilarItemAlertsTableRow
                dateAdded={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'dateAdded'])}
                    </Caption>
                }
                item={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'item'])}
                    </Caption>
                }
                lastAlert={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'lastAlert'])}
                    </Caption>
                }
            />
            {alerts.map((alert) => (
                <MySimilarItemAlertRow
                    alert={alert}
                    key={alert.savedItemId}
                />
            ))}
        </>
    );
};
